/**
 *
 */

import {config} from '../config';
import {handleResponse} from "../helpers/response";
import i18n from 'i18next';

export const RECEIVED_LIST_FILTERS_TRIGGERED = 'RECEIVED_LIST_FILTERS_TRIGGERED';
export const RECEIVED_LIST_DATA = 'RECEIVED_LIST_DATA';
export const RECEIVED_SORTING_LIST_DATA = 'RECEIVED_SORTING_LIST_DATA';
export const RECEIVED_LIST_PAGINATOR_TRIGGERED = 'RECEIVED_LIST_PAGINATOR_TRIGGERED';
export const RECEIVED_LIST_LIMIT_PAGE = 'RECEIVED_LIST_LIMIT_PAGE';
export const RECEIVED_LIST_WITH_SEARCH = 'RECEIVED_LIST_WITH_SEARCH';
export const RECEIVED_SEARCH_DATA = 'RECEIVED_SEARCH_DATA';
export const RECEIVED_SEARCH_DATA_ART = 'RECEIVED_SEARCH_DATA_ART';
export const RECEIVED_CART_DATA = 'RECEIVED_CART_DATA';
export const RECEIVED_WISH_DATA = 'RECEIVED_WISH_DATA';
export const RECEIVED_COMPARE_DATA = 'RECEIVED_COMPARE_DATA';
export const PRODUCTS_CART_ADDED_DATA = 'PRODUCTS_CART_ADDED_DATA';
export const PRODUCTS_WISH_ADDED_DATA = 'PRODUCTS_WISH_ADDED_DATA';
export const PRODUCTS_COMPARE_ADDED_DATA = 'PRODUCTS_COMPARE_ADDED_DATA';
export const REMOVED_WISH_DATA = 'REMOVED_WISH_DATA';
export const REMOVED_COMPARE_DATA = 'REMOVED_COMPARE_DATA';
export const SHOW_LOADER_ACTION = 'SHOW_LOADER_ACTION';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';
export const CLEAR_SEARCH_DATA='CLEAR_SEARCH_DATA';

/**
 * Gets cart wish data
 *
 * @returns {function(...[*]=)}
 */
export function getsCartData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/cart/get/";
        dispatch(showLoader());
        fetch(link).then( handleResponse ).then( json => {
            dispatch(setCartData(json));
        });
    }
}

export function clearFilters(){
    return {
        type: CLEAR_FILTERS
    }
}

export function getsCompareData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/ua/comparelist/count/';
        dispatch(showLoader());
        fetch(link).then(handleResponse).then( json => {
            //console.log("json 3838383838" , json );
            dispatch(setCompareData(json));
        })
    }
}

export function getsWishData(){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/wishlist/count/";
        dispatch(showLoader());
        fetch(link).then(handleResponse).then(json => {
            dispatch(setWishData(json));
        });
    }
}

export function addToCart(id){
    // console.log("IDIDIDIDIDIDI ", id);
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl + "api/cart/add/";
        const formData  = new FormData();
        formData.append("good_id", id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, { method: 'POST', body: formData} ).then(handleResponse).then(json => {
            dispatch(addedToCart(id));
        })
    }
}

export function removeFromWish(id) {
    return (dispatch, getState) => {
        const formData = new FormData();
        dispatch(showLoader());
        formData.append("good_id", id);
        formData.append('tok_', getState().user.userInfo._tok );
        var link = config.apiUrl + 'api/wishlist/remove/';
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(removedFromWish(id));
        })

    }
}

export function removedFromWish(id){
    return {
        type: REMOVED_WISH_DATA,
        id: id
    }
}

export function addToWish(id){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/wishlist/add/";
        const formData  = new FormData();
        dispatch(showLoader());
        formData.append("product_id", id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, { method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(addedToWish(id));
        })
    }
}

export function addToCompare(id){
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/comparision/add/";
        const formData  = new FormData();
        dispatch(showLoader());
        formData.append("product_id", id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, { method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(addedToCompare(id));
        })
    }
}

export function removeFromCompare(id){
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl + "api/compare/remove/";
        const formData = new FormData();
        formData.append('good_id', id);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
           dispatch(removedFromCompare(id));
        });
    }
}

/**
 * Sets cart data
 *
 * @param data
 * @returns {{countCart: *, type: string}}
 */
export function setCartData( data ){
    return {
        type: RECEIVED_CART_DATA,
        countCart: data.countItem
    }
}

/**
 * Set wish data action
 *
 * @param data
 * @returns {{countWish: *, type: string}}
 */
export function setWishData(data){
    return {
        type: RECEIVED_WISH_DATA,
        countWish: data.countItem
    }
}

/**
 * Added to cart
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
export function addedToCart(id){
    return {
        type: PRODUCTS_CART_ADDED_DATA,
        id: id
    }
}

/**
 *Added to wishlist
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
export function addedToWish(id){
    return {
        type: PRODUCTS_WISH_ADDED_DATA,
        id: id
    }
}

/**
 * Add to compare
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
export function addedToCompare(id){
    return {
        type: PRODUCTS_COMPARE_ADDED_DATA,
        id: id
    }
}

export function removedFromCompare(id){
    return {
        type: REMOVED_COMPARE_DATA,
        id: id
    }
}

/**
 * Set wish data action
 *
 * @param data
 * @returns {{countWish: *, type: string}}
 */
export function setCompareData(data){
    return {
        type: RECEIVED_COMPARE_DATA,
        countCompare: data.countItem
    }
}


export const clearSearchData = ()=>{
    return (dispatch,getState) =>{
        dispatch({
            type: CLEAR_SEARCH_DATA
        })
    }
}



export function receivingList(category,filterData, language ){
    return (dispatch, getState) => {
        // console.log(' config api url 111111', filterData);
        // console.log(' config api url 111111', filterData.length);
        dispatch(showLoader());

        let filterPart = '';
        if ( filterData.filterPart !== undefined){
            filterPart = filterData['filterPart'];
        }

        let categoryPart = '';
        if (category){
            categoryPart = category;
        }
        var link = config.apiUrl+"api/shop/"+i18n.language+"/"+categoryPart+`${filterPart?"/"+filterPart:''}`;
        // console.log(" lin??? k ", link );
        fetch(link).then( handleResponse ).then( json => {
            // console.log("LIIIIIIIIIIIINK19", json.numItemsPerPage);
            dispatch(receivedListData(json,category,filterData));
        });
    }
}

/**
 * All required props already in store, just add
 *
 * @returns {function(...[*]=)}
 */
export function submitFilters(){
    return (dispatch, getState) =>{
        let state = getState();
        dispatch(showLoader());
        // console.log("state submit filters ", state);
        // console.log("state goods minMax", state.goods.minMaxSelected);
        let separatorLink = "?";


        let partFiltersCheckboxes = '';
        if ( state.goods.conditionSelected.length > 0 ){
            partFiltersCheckboxes = state.goods.conditionSelected.join("+");
            // console.log("partFiltersCheckboxespartFiltersCheckboxes", partFiltersCheckboxes);
        }

        let partMinMaxFilters = '';
        if ( Object.keys(state.goods.minMaxSelected).length > 0 ){
            partMinMaxFilters = _createsMinMaxUrlPart(state.goods.minMaxSelected);
        }

        var filterLink =  '';
        if ( partMinMaxFilters !== '' || partFiltersCheckboxes !== '' ){
            filterLink = separatorLink+"filter="+partFiltersCheckboxes+partMinMaxFilters;
            separatorLink = "&";
        }

        let categoryPart = '';
        if ( state.goods.currentCategory != null ){
            categoryPart = state.goods.currentCategory;
        }

        let sortingPart = '';
        if ( state.goods.sortingData.length ){
            // console.log("sorting DATA 101 ", state.goods);
            sortingPart = separatorLink+'sorting='+state.goods.sortingData[0]+"+"+state.goods.sortingData[1];
            separatorLink = '&';
        }

        let limitOffset = separatorLink+"page="+1+"&limit="+state.goods.limit;
        separatorLink = '&';
        let searchLink = '';
        if (state.goods.search) {
            searchLink = separatorLink + "search=" + state.goods.search;
        }

        let isDiscountLink = '';
        if (state.goods.isDiscount){
            isDiscountLink = separatorLink + "is_discount=1";
        }

        var link = '';
        link = config.apiUrl + 'api/shop/'+i18n.language+"/"+categoryPart+filterLink+sortingPart+limitOffset+searchLink+isDiscountLink;
        let urlForChange = categoryPart+filterLink+sortingPart+limitOffset+searchLink+"&lng="+i18n.language;
        // console.log(" url>>for>>change ", urlForChange );
        fetch(link).then(handleResponse).then(json => {
            dispatch(receivedListFiltersTriggered(json, state.goods.currentCategory, urlForChange));
        });
    }
}

let _createsMinMaxUrlPart = ( data ) =>{
    let url = [];
    if (Object.keys(data).length){
        Object.keys(data).forEach((itm,inx)=>{
            url.push(itm +"-min-"+data[itm].min);
            url.push(itm +"-max-"+data[itm].max);
        })
    }
    return url.length?"+"+url.join("+"):"";
}


/**
 * Handle find data
 *
 * @param search
 */
export function handleSearchData(search){
    return (dispatch, getState) => {
        let state = getState();
        dispatch(showLoader());

        let separatorLink = "?";

        let partFiltersCheckboxes = '';
        if ( state.goods.conditionSelected.length > 0 ){
            partFiltersCheckboxes = state.goods.conditionSelected.join("+");
            // console.log("partFiltersCheckboxespartFiltersCheckboxes", partFiltersCheckboxes);
        }

        let partMinMaxFilters = '';
        if ( Object.keys(state.goods.minMaxSelected).length > 0 ){
            partMinMaxFilters = _createsMinMaxUrlPart(state.goods.minMaxSelected);
        }

        var filterLink =  '';
        if ( partMinMaxFilters !== '' || partFiltersCheckboxes !== '' ){
            filterLink = separatorLink+"filter="+partFiltersCheckboxes+partMinMaxFilters;
            separatorLink = "&";
        }

        let categoryPart = '';
        if ( state.goods.currentCategory != null ){
            categoryPart = state.goods.currentCategory;
        }

        let sortingPart = '';
        if ( state.goods.sortingData.length ){
            // console.log("sorting DATA 101 ", state.goods);
            sortingPart = separatorLink+'sorting='+state.goods.sortingData[0]+"+"+state.goods.sortingData[1];
            separatorLink = '&';
        }

        let limitOffset = separatorLink+"page="+1+"&limit="+state.goods.limit;
        separatorLink = '&';
        let searchLink = separatorLink +"search="+state.goods.search;

        var link = '';
        link = config.apiUrl + 'api/shop/'+i18n.language+"/"+categoryPart+filterLink+sortingPart+limitOffset+searchLink;
        let urlForChange = '/products/'+i18n.language+'/'+filterLink+sortingPart+limitOffset+searchLink+"&lng="+i18n.language;
        // console.log("364 364  categoryPart 364 364 364 364", categoryPart );
         console.log("url for change 364", urlForChange);
        // dispatch(receivedSearch(search));
         console.log( "link sorting 115 115 list", link );
        fetch(link).then(handleResponse).then(json => {
            dispatch(receivedListWithSearch(json, 1, urlForChange));
        });
    }
}

/**
 * Received search
 *
 * @param search
 */
export function receivedSearch(search){
    return {
        type: RECEIVED_SEARCH_DATA,
        search: search
    }
}

/**
 * Received search
 *
 * @param search
 */
export function receivedSearchArt(search){
    return {
        type: RECEIVED_SEARCH_DATA_ART,
        searchArt: search
    }
}

/**
 *
 * @param json
 * @param search
 * @param page
 * @param urlForChange
 */
export function receivedListWithSearch(json, page, url){
    return {
        type: RECEIVED_LIST_WITH_SEARCH,
        listGoods: json,
        pageNum: page,
        urlForChange: url
    }
}

/**
 * Handle change limit offset
 *
 * @param limit
 * @returns {function(...[*]=)}
 */
export function handleChangeLimitOffset(limit){
    return (dispatch,getState) => {
        let state = getState();
        dispatch(showLoader());

        // console.log("state submit filters ", state);
        // console.log("state goods minMax", state.goods.minMaxSelected);
        let separatorLink = "?";

        let partFiltersCheckboxes = '';
        if ( state.goods.conditionSelected.length > 0 ){
            partFiltersCheckboxes = state.goods.conditionSelected.join("+");
            // console.log("partFiltersCheckboxespartFiltersCheckboxes", partFiltersCheckboxes);
        }

        let partMinMaxFilters = '';
        if ( Object.keys(state.goods.minMaxSelected).length > 0 ){
            partMinMaxFilters = _createsMinMaxUrlPart(state.goods.minMaxSelected);
        }

        var filterLink =  '';
        if ( partMinMaxFilters !== '' || partFiltersCheckboxes !== '' ){
            filterLink = separatorLink+"filter="+partFiltersCheckboxes+partMinMaxFilters;
            separatorLink = "&";
        }

        let categoryPart = '';
        if ( state.goods.currentCategory != null ){
            categoryPart = state.goods.currentCategory;
        }

        let sortingPart = '';
        if ( state.goods.sortingData.length ){
            // console.log("sorting DATA 101 ", state.goods);
            sortingPart = separatorLink+'sorting='+state.goods.sortingData[0]+"+"+state.goods.sortingData[1];
            separatorLink = '&';
        }

        let limitOffset = separatorLink+"page="+1+"&limit="+limit;
        separatorLink = '&';

        let searchLink = '';
        console.log("state goooods ", state.goods.search, state.goods.search === null, state.goods.searchArt, separatorLink );
        if (state.goods.search || state.goods.searchArt) {
            searchLink = separatorLink + `${state.goods.search?'search='+state.goods.search:'searchArt='+state.goods.searchArt}`;
            separatorLink = '&';
        }


        let isDiscountLink = '';
        if (state.goods.isDiscount){
            isDiscountLink = separatorLink + "is_discount=1";
            separatorLink = '&';
        }

        var link = '';
        link = config.apiUrl + 'api/shop/'+i18n.language+"/"+categoryPart+filterLink+sortingPart+limitOffset+searchLink+isDiscountLink;
        // console.log( "link sorting 106 106 list", link );

        let urlForChange = categoryPart+filterLink+sortingPart+limitOffset+searchLink+"&lng="+i18n.language;
        // console.log("urlForChange urlForChangeurlForChangeurlForChangeurlForChangeurlForChange ", urlForChange);
        fetch(link).then(handleResponse).then(json => {
            dispatch(receivedListLimitPage(json, limit, 1, urlForChange));
        });
    }
}

/**
 * Receiver list limit page
 *
 * @param json
 * @param limit
 * @param urlForChange
 */
export function receivedListLimitPage(json, limit,pageNum,urlForChange){
    return {
        type: RECEIVED_LIST_LIMIT_PAGE,
        listGoods: json,
        limit: limit,
        urlForChange: urlForChange,
        pageNum: pageNum
    }
}


/**
 * Click to paginator page
 *
 * @param pageClicked
 */
export function handleClickPaginator(pageClicked) {

    return (dispatch, getState) =>{
        dispatch(showLoader());
        let state = getState();
        // console.log("state submit filters ", state);
        // console.log("state goods minMax", state.goods.minMaxSelected);
        let separatorLink = "?";

        let partFiltersCheckboxes = '';
        if ( state.goods.conditionSelected.length > 0 ){
            partFiltersCheckboxes = state.goods.conditionSelected.join("+");
            // console.log("partFiltersCheckboxespartFiltersCheckboxes", partFiltersCheckboxes);
        }

        let partMinMaxFilters = '';
        if ( Object.keys(state.goods.minMaxSelected).length > 0 ){
            partMinMaxFilters = _createsMinMaxUrlPart(state.goods.minMaxSelected);
        }

        var filterLink =  '';
        if ( partMinMaxFilters !== '' || partFiltersCheckboxes !== '' ){
            filterLink = separatorLink+"filter="+partFiltersCheckboxes+partMinMaxFilters;
            separatorLink = "&";
        }

        let categoryPart = '';
        if ( state.goods.currentCategory != null ){
            categoryPart = state.goods.currentCategory;
        }

        let sortingPart = '';
        if ( state.goods.sortingData.length ){
            // console.log("sorting DATA 101 ", state.goods);
            sortingPart = separatorLink+'sorting='+state.goods.sortingData[0]+"+"+state.goods.sortingData[1];
            separatorLink = '&';
        }

        let limitOffset = '';
        if ( pageClicked ){
            limitOffset = separatorLink+"page="+pageClicked+"&limit="+state.goods.limit;
            separatorLink = '&';
        }

        let searchLink = '';
        console.log("state goooods ", state.goods.search, state.goods.search === null, state.goods.searchArt, separatorLink );
        if (state.goods.search || state.goods.searchArt) {
            searchLink = separatorLink + `${state.goods.search?'search='+state.goods.search:'searchArt='+state.goods.searchArt}`;
            separatorLink = '&';
        }


        let isDiscountLink = '';
        if (state.goods.isDiscount){
            isDiscountLink =  "&is_discount=1";
            separatorLink = '&';
        }

        console.log("isDiscont ", isDiscountLink);

        var link = '';
        link = config.apiUrl + 'api/shop/'+i18n.language+"/"+categoryPart+"/"+filterLink+sortingPart+limitOffset+searchLink+isDiscountLink;
        // console.log( "link sorting 106 106 list", link );

        let urlForChange = categoryPart+filterLink+sortingPart+limitOffset+searchLink+"&lng="+i18n.language;

        fetch(link).then(handleResponse).then(json => {
            dispatch(receivedListPaginatorTriggered(json, {page:pageClicked,limit: state.goods.limit}, urlForChange));
        });
    }
}


export function receivedListPaginatorTriggered( json, objectPageLimit, urlForChange ){
    return {
        type: RECEIVED_LIST_PAGINATOR_TRIGGERED,
        listGoods: json,
        objectPageLimit: objectPageLimit,
        urlForChange: urlForChange
    }
}

/**
 * Shows loader action
 *
 * @returns {{type: string}}
 */
export function showLoader(){
    return {
        type: SHOW_LOADER_ACTION,
    }
}

/**
 * Sorting list current
 *
 * @param sortData
 * @returns {function(...[*]=)}
 */
export function sortingListCurrent(sortData){

    return (dispatch, getState) => {
        dispatch(showLoader());
        let state = getState();
        let separatorLink = "?";

        let partFiltersCheckboxes = '';
        if ( state.goods.conditionSelected.length > 0 ){
            partFiltersCheckboxes = state.goods.conditionSelected.join("+");
            // console.log("partFiltersCheckboxespartFiltersCheckboxes", partFiltersCheckboxes);
        }

        let partMinMaxFilters = '';
        if ( Object.keys(state.goods.minMaxSelected).length > 0 ){
            partMinMaxFilters = _createsMinMaxUrlPart(state.goods.minMaxSelected);
        }

        var filterLink =  '';
        if ( partMinMaxFilters !== '' || partFiltersCheckboxes !== '' ){
            filterLink = separatorLink+"filter="+partFiltersCheckboxes+partMinMaxFilters;
            separatorLink = "&";
        }

        let categoryPart = '';
        if ( state.goods.currentCategory != null ){
            categoryPart = state.goods.currentCategory;
        }

        let sortingPart = '';
        if ( sortData.length > 0 ){
            sortingPart = separatorLink+'sorting='+sortData[0]+"+"+sortData[1];
            separatorLink = '&';
        }

        let searchLink = '';
        if (state.goods.search || state.goods.searchArt) {
            searchLink = separatorLink + `${state.goods.search?'search='+state.goods.search:'searchArt='+state.goods.searchArt}`;
            separatorLink = '&';
        }

        let isDiscountLink = '';
        if (state.goods.isDiscount){
            isDiscountLink = separatorLink + "is_discount=1";
            separatorLink = '&'
        }

        let limitOffset = separatorLink+"page="+state.goods.pageNum+"&limit="+state.goods.limit;

        var link = '';
        link = config.apiUrl + 'api/shop/'+i18n.language+"/"+categoryPart+"/"+filterLink+sortingPart+searchLink+isDiscountLink+limitOffset;
        // console.log( "link sorting list", link );

        let urlForChange = categoryPart+filterLink+sortingPart+searchLink+limitOffset+"&lng="+i18n.language;

        fetch(link).then( handleResponse ).then( json => {
            dispatch(receivedSortingListData(json, sortData,urlForChange));
        });

    }
}

/**
 *
 * @param listGoods
 * @param orderingData
 * @param urlForChange
 * @returns {{urlForChange: *, type: string, listGoods: *, orderingData: *}}
 */
export function receivedSortingListData(listGoods, orderingData, urlForChange){
    return {
        type: RECEIVED_SORTING_LIST_DATA,
        listGoods: listGoods,
        orderingData: orderingData,
        urlForChange: urlForChange
    }
}

/**
 * received Menu
 *
 * @param dataList
 * @returns {{type: string, listGoods: *}}
 */
export function receivedListFiltersTriggered(listGoods, category, url){
    return {
        type: RECEIVED_LIST_FILTERS_TRIGGERED,
        listGoods: listGoods,
        currentCategory: category,
        url: url,

    }
}

export function clearAllStates() {
    return {
        type: CLEAR_ALL_STATES
    }
}

export function receivedListData(listGoods, category,filters){
    return {
        type: RECEIVED_LIST_DATA,
        listGoods: listGoods,
        category: category,
        filters: filters
    }

}